/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pageable } from '../models/Pageable';
import type { PageNotificationDto } from '../models/PageNotificationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationControllerService {
    /**
     * @param userId
     * @returns number OK
     * @throws ApiError
     */
    public static getUnreadCount(
        userId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/{userId}/notifications/unread-count',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static markAsRead(
        userId: number,
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/{userId}/notifications/{id}/read',
            path: {
                'userId': userId,
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @param pageable
     * @returns PageNotificationDto OK
     * @throws ApiError
     */
    public static getNotifications(
        userId: number,
        pageable: Pageable,
    ): CancelablePromise<PageNotificationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/{userId}/notifications',
            path: {
                'userId': userId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
}
